import React from 'react'
import "./GreenProgressBar.css"
export default function GreenProgressBar(props) {
  return (
    <div className='green-progress-bar__container'>
    <div class="meter">
    <span style={{width:`${props.progress}%`}}></span>
    </div>
    </div>
  )
}
